<template>
  <div id="express-checkout-element-or" class="relative hidden">
    <div class="absolute inset-0 flex items-center" aria-hidden="true">
      <div class="w-full border-t border-dark-100" />
    </div>
    <div class="relative flex justify-center">
      <span class="bg-white px-2 text-sm text-dark-200">or</span>
    </div>
  </div>
</template>
